var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTired({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M44.7693,14.7308c-0.3678-0.1518-0.7405-0.2944-1.1176-0.4274C41.258,13.4592,38.6826,13,36,13c-12.7031,0-23,10.2969-23,23 c0,12.7022,10.2969,23,23,23c12.7022,0,23-10.2978,23-23c0-2.8236-0.5088-5.5284-1.4397-8.0276"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 48.1435,
    r: 3.4042,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M50.1652,32.8593c-3.1758,2.3436-7.4563,2.061-10,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M31.8348,32.8593c-3.1758,2.3436-7.4563,2.061-10,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8748,24.0258h-2.6162c-0.3564,0-0.6855-0.1899-0.8652-0.498c-0.1787-0.3086-0.1797-0.6885-0.0029-0.998l1.7607-3.082 h-0.8926c-0.5527,0-1-0.4478-1-1s0.4473-1,1-1h2.6162c0.3564,0,0.6855,0.1899,0.8652,0.498 c0.1787,0.3086,0.1797,0.6885,0.0029,0.998l-1.7607,3.082h0.8926c0.5527,0,1,0.4478,1,1S45.4275,24.0258,44.8748,24.0258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0184,20.0258h-3.7598c-0.3564,0-0.6855-0.1899-0.8652-0.498c-0.1787-0.3086-0.1797-0.6885-0.0029-0.998l2.9043-5.082 h-2.0361c-0.5527,0-1-0.4478-1-1s0.4473-1,1-1h3.7598c0.3564,0,0.6855,0.1899,0.8652,0.498 c0.1787,0.3086,0.1797,0.6885,0.0029,0.998l-2.9044,5.082h2.0361c0.5527,0,1,0.4478,1,1S51.5711,20.0258,51.0184,20.0258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1609,25.0258h-4.9023c-0.3564,0-0.6855-0.1899-0.8652-0.498c-0.1787-0.3086-0.1797-0.6885-0.0029-0.998l4.0469-7.082 h-3.1787c-0.5527,0-1-0.4478-1-1s0.4473-1,1-1h4.9023c0.3564,0,0.6855,0.1899,0.8652,0.498 c0.1787,0.3086,0.1797,0.6885,0.0029,0.998l-4.0469,7.082h3.1787c0.5527,0,1,0.4478,1,1S59.7137,25.0258,59.1609,25.0258z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTired);
export default __webpack_public_path__ + "static/media/Tired.1c6bdbdb508548773d29583d961d37f1.svg";
export { ForwardRef as ReactComponent };